const SET_USERS_LIST = '@users/set-users-list';
const SET_USERS_DETAIL = '@users/set-users-detail';
const SET_LIST_BANK = '@users/set-list-bank';

export {SET_USERS_LIST, SET_USERS_DETAIL, SET_LIST_BANK};